import { render } from "./FileUpload.vue?vue&type=template&id=52756b6c"
import script from "./FileUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./FileUpload.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Public/FileUpload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52756b6c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52756b6c', __exports__)) {
    api.reload('52756b6c', __exports__)
  }
  
  module.hot.accept("./FileUpload.vue?vue&type=template&id=52756b6c", () => {
    api.rerender('52756b6c', render)
  })

}


export default __exports__